import React from "react";
import PropTypes from "prop-types";
import Str from "shared/components/Str";
import AppPhoneCommand from "shared/util/AppPhoneCommand";
import {
	SUBTYPE_TO_TOKEN_TYPE_MAP,
	PAYPAL_PAYMENT_PROCESSOR,
} from "shared/payment/constants";
import {
	selectedPaymentTypeOnCheckoutEvent,
} from "shared/payment/analytics";
import _str from "shared/util/_str";

import "./ThirdPartyPaymentOptions.scss";

const PAYMENT_OPTIONS = {
	GOOGLE_PLAY: "native",
	CREDIT_CARD: "credit_card",
	PAYPAL: "paypal",
};

function openGooglePlayStore({ productId, feature, tokenType, isSubscription }) {
	AppPhoneCommand("purchase", {
		parameters: {
			closePaymentForm: true,
			purchaseParams: {
				consumable: null,
				extra: {
					feature,
					nativeRateCard: true,
					token_type: tokenType,
				},
				product_id: productId,
				subscription: isSubscription,
			},
		},
	}, "() => {}");
}

const ThirdPartyPaymentOptions = ({
	paymentOptions,
	isSubscription,
	tokenType,
	feature,
	productId,
	setPayPalScreen,
	rateCardName,
	productSubtype,
	productType,
	currency,
	subscriptionSubPeriod,
	tokensCount,
	productPrice,
	subPeriodType,
	isPayPalScreen,
	isSavedCreditCard,
	upgradePrice,
}) => {
	const isGooglePlayAvailable = paymentOptions
		.some((paymentOption) => paymentOption === PAYMENT_OPTIONS.GOOGLE_PLAY);

	const hasPayPal = paymentOptions
		.some((paymentOption) => paymentOption === PAYMENT_OPTIONS.PAYPAL);

	const hasBothPaymentOptionsAvailable = isGooglePlayAvailable && hasPayPal;

	if (!isGooglePlayAvailable && !hasPayPal) return null;

	const buttonCTA = isPayPalScreen ? _str("Credit Card") : _str("PayPal");

	return (
		<div className="third-party-payment-options">
			<Str>Pay with</Str>{" "}
			{isGooglePlayAvailable
				&& (
					<button
						onClick={() => {
							// analytics
							selectedPaymentTypeOnCheckoutEvent({
								upgradePrice,
								rateCardName,
								isDefaultPaymentType: false,
								isSavedCreditCard: false,
								paymentType: "google play",
								productSubtype,
								productType,
								paymentOptions,
								currency,
								subscriptionSubPeriod,
								tokensCount,
								unitPrice: productPrice,
								subPeriodType,
							});

							openGooglePlayStore({
								isSubscription,
								tokenType,
								feature,
								productId,
							});
						}}
						className="third-party-payment-options-button"
					>
						Google Play&nbsp;
					</button>
				)
			}
			{hasBothPaymentOptionsAvailable
				&& <Str>or&nbsp;</Str>
			}
			{hasPayPal
				&& (
					<button
						onClick={() => {
							// analytics
							selectedPaymentTypeOnCheckoutEvent({
								upgradePrice,
								rateCardName,
								isDefaultPaymentType: !isPayPalScreen,
								isSavedCreditCard: !isPayPalScreen && isSavedCreditCard,
								paymentType: isPayPalScreen ? PAYPAL_PAYMENT_PROCESSOR : "cc",
								productSubtype,
								productType,
								paymentOptions,
								currency,
								subscriptionSubPeriod,
								tokensCount,
								unitPrice: productPrice,
								subPeriodType,
							});

							setPayPalScreen(!isPayPalScreen);
						}}
						className="third-party-payment-options-button"
					>
						{buttonCTA}
					</button>
				)
			}
		</div>
	);
};

ThirdPartyPaymentOptions.propTypes = {
	paymentOptions: PropTypes.array.isRequired,
	isSubscription: PropTypes.bool,
	tokenType: PropTypes.oneOf(Object.values(SUBTYPE_TO_TOKEN_TYPE_MAP)),
	feature: PropTypes.oneOf(Object.values(SUBTYPE_TO_TOKEN_TYPE_MAP)),
	productId: PropTypes.string.isRequired,
	setPayPalScreen: PropTypes.func.isRequired,
	rateCardName: PropTypes.string,
	productSubtype: PropTypes.string.isRequired,
	productType: PropTypes.string,
	subscriptionSubPeriod: PropTypes.number,
	currency: PropTypes.string.isRequired,
	tokensCount: PropTypes.number,
	productPrice: PropTypes.string.isRequired,
	subPeriodType: PropTypes.string,
	isPayPalScreen: PropTypes.bool,
	isSavedCreditCard: PropTypes.bool,
	upgradePrice: PropTypes.number,
};

ThirdPartyPaymentOptions.defaultProps = {
	rateCardName: null,
	productType: null,
	isSubscription: false,
	tokenType: null,
	feature: null,
	subscriptionSubPeriod: null,
	tokensCount: null,
	subPeriodType: null,
	isPayPalScreen: false,
	isSavedCreditCard: false,
	upgradePrice: null,
};

export default ThirdPartyPaymentOptions;



// WEBPACK FOOTER //
// ./src/apps/payment/components/ThirdPartyPaymentOptions/ThirdPartyPaymentOptions.jsx